var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifiSignal1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#40b4b0",
    d: "M606.7,732.6c58.9,58.8,58.9,154.3,0,213.2c-58.8,58.9-154.3,58.9-213.2,0c-58.9-58.9-58.9-154.4,0-213.2C452.4,673.7,547.9,673.7,606.7,732.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#40b4b0",
    d: "M686.5,511.4c-115.2-65.5-258.3-65.4-373.5,0.4c-36.2,20.7-48.7,66.8-28,102.9c13.9,24.3,39.3,37.9,65.5,37.9c12.7,0,25.5-3.2,37.3-9.9c69.1-39.5,154.9-39.8,224-0.3c36.2,20.5,82.2,8,102.9-28.2C735.3,578.1,722.6,532.1,686.5,511.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M799.7,315.5c-184.8-105.7-414.3-105.7-598.9,0c-36.2,20.6-48.7,66.7-28,102.9c20.7,36.1,66.8,48.7,102.9,28c138.4-79.1,310.5-79.3,449.1,0.1c11.9,6.8,24.7,9.9,37.4,9.9c26.1,0,51.6-13.6,65.5-37.9C848.3,382.2,835.7,336.1,799.7,315.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M911.6,118.9C657.6-26.3,342.2-26.3,88.4,119c-36.2,20.6-48.7,66.7-28,102.9c13.9,24.4,39.3,37.9,65.5,37.9c12.7,0,25.6-3.2,37.4-9.9C371,131,628.8,130.9,836.6,249.8c36.3,20.6,82.2,8.1,102.9-28C960.2,185.7,947.6,139.6,911.6,118.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiSignal1);
export default __webpack_public_path__ + "static/media/wifi_signal_1.58b3db87d9d2626f78fcde597c8f246c.svg";
export { ForwardRef as ReactComponent };